<template>
  <div
    class="status-bar"
    :class="{
      'current-space-page': getIfOnCurrentUsersRoomPage,
      'external-meeting': conferenceType !== 'spacein'
    }"
    @mousemove="handleMouseMove"
  >
    <template v-if="conferenceType === 'spacein' && staticData.id !== getCurrentAreaHubId">
      <JitsiIframe :currentRoomData="staticData" />

      <div
        v-if="!vm['sidebar/isOpen']"
        class="status-bar-search"
        :style="{opacity: shouldShowSearch ? '0.5' : '0'}"
      ><SearchBar :hollow="true"/></div>
    </template>

    <Livestream
      v-if="conferenceType === 'livestream'"
      :roomData="staticData"
    />

    <Networking
      v-if="conferenceType === 'networking' || conferenceType == 'internal'"
      :roomData="staticData"
    />

    <div v-if="conferenceType === 'unknown' || conferenceType == 'link'" class="external-link">
      <p>External link open in another tab</p>
      <btn class="reopen-link" rounded border large @onClick="reopenExternalLink()">
        <template #text>
          <b>Reopen link</b>
        </template>
      </btn>
    </div>
  </div>
</template>

<script>
import JitsiIframe from '@/components/conferencing/JitsiIframe.vue';
import Livestream from '@/components/conferencing/Livestream.vue';
import Networking from '@/components/conferencing/NetworkingIframe.vue';
import SearchBar from '@/components/search/SearchBar.vue';

import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'VideoConferenceWrapper',
  components: {
    JitsiIframe,
    Livestream,
    Networking,
    SearchBar
  },
  data(vm) {
    // todo: fix data inconsistency when joining from lobby vs. when you are already joined, and refresh the page
    // console.log("CREATING VC:", JSON.stringify(vm.$store.getters.getCurrentUsersRoom, null, 4));
    return {
      ifPresentInterval: false,
      mouseMoveTimeout: 0,
      showSearch: true,
      staticData: vm.$store.getters.getCurrentUsersRoom,
    };
  },
  computed: {
    ...mapGetters(['getCurrentUsersRoom', 'getIfOnCurrentUsersRoomPage', 'getCurrentAreaHubId', 'sidebar/isOpen']),
    ...mapGetters({
      isMobile: 'viewport/isMobile',
      isLandscape: 'viewport/isLandscape',
      height: 'viewport/height'
    }),
    conferenceType: vm => vm.staticData?.conferenceType,
    vm: vm => vm,
    shouldShowSearch: function() {
      if (this.isMobile) {
        return true
      } else {
        return this.showSearch
      }
    }
  },
  watch: {
    isMobile: function() {
      this.checkIfShouldShowSidebar()
    },
    height: function() {
      this.checkIfShouldShowSidebar()
    },
    async getCurrentUsersRoom(newVal){
      // nulling and un-nulling the data will cause the child component to unmount and re-mount, resetting i
      if(newVal.id !== this.staticData.id) {
        this.staticData = null;
        await this.$nextTick();
        this.staticData = newVal;
      }
      // for livestreams, to keep the number up to date
      if(typeof newVal?.online === 'number') this.staticData.online = newVal.online;
    }
  },
  methods: {
    ...mapActions(['handleLeaveRoom', 'handleOpenRoomLink', 'sidebar/show', 'sidebar/hide']),
    handleMouseMove(){
      this.showSearch = true;
      clearTimeout(this.mouseMoveTimeout);
      this.mouseMoveTimeout = setTimeout(() => this.showSearch = false, 3500);
    },
    reopenExternalLink() {
      this.handleOpenRoomLink(this.staticData)
    },
    checkIfShouldShowSidebar() {
      if (this.isMobile && this.isLandscape && this.height < 500) { //only if not enough room for sidebar (so doesn't not show on small desktop close to square,etc)
        this['sidebar/hide']()
      } else {
        this['sidebar/show']()
      }
    }
  },
  mounted() {
    this.handleMouseMove();
    this.checkIfShouldShowSidebar()
  },
  beforeDestroy() {
    this['sidebar/show']()
  }
};
</script>
<style lang="scss">
@import '~@/scss/components/conferencing/video_conference_wrapper.scss';
</style>
